"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ponte-di-legno": {
    "81ea8d72": [{
      "hkey": "69e6b49c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "poia": [{
      "hkey": "69e6b49c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ponte-di-legno"
    }],
    "2608ef89": [{
      "hkey": "3eb1a583",
      "slug": "ponte-di-legno",
      "name": "Ponte di Legno",
      "primary": true,
      "skipSearch": false
    }],
    "sant-apollonia": [{
      "hkey": "3eb1a583",
      "slug": "ponte-di-legno",
      "name": "Ponte di Legno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8cc4b073": [{
      "hkey": "3eb1a583",
      "slug": "ponte-di-legno",
      "name": "Ponte di Legno",
      "primary": true,
      "skipSearch": false
    }],
    "zoanno": [{
      "hkey": "3eb1a583",
      "slug": "ponte-di-legno",
      "name": "Ponte di Legno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;